import React from 'react'
import AdmBookDashboard from '../../components/AdminTabs/AdminBookDashboard/AdmBookDashboard'
const BookDashboard = () => {
  return (
    <div>
        <AdmBookDashboard/>
    </div>
  )
}

export default BookDashboard